import { FC } from 'react';
import { useWatch } from 'react-hook-form';

import {
  OPTIMIZE_PERIOD,
  SchemaFormKeys,
  OPTIMIZE_MIN_ALLOWED,
  OPTIMIZE_MAX_ALLOWED,
} from 'modules/frequencyManagement/contexts/FormProvider';
import {
  EditingInputRow,
  FlexSummaryInset,
} from 'modules/frequencyManagement/components/optimize/Optimize.styles';
import { Histogram } from 'modules/frequencyManagement/components/histogram/Histogram';
import { FrequencyPeriod, HistogramData } from 'modules/frequencyManagement/lib/types';
import { LABEL_BY_PERIOD } from 'modules/frequencyManagement/lib/constants';
import { OptimizeInputFields } from 'modules/frequencyManagement/components/optimize/OptimizeInputFields';
import { OptimizeReadyEditTestId } from 'modules/frequencyManagement/components/optimize/Optimize.constants';
import { OptimizeFormLabel } from 'modules/frequencyManagement/components/optimize/OptimizeFormLabel';
import { OptimizeBaseProps } from 'modules/frequencyManagement/components/optimize/Optimize.types';
import { ConnectedFormMultiField } from 'modules/frequencyManagement/components/connectedFormMultiField/ConnectedFormMultiField';
import { WithCollapsibleReadyContent } from 'modules/frequencyManagement/components/optimize/WithCollapsibleReadyContent';

interface OptimizeReadyEditProps extends OptimizeBaseProps {
  histogramData: HistogramData;
  lastUpdated: string;
}
export const OptimizeReadyEdit: FC<OptimizeReadyEditProps> = ({
  histogramData,
  lastUpdated,
  rootName,
}) => {
  const minName = rootName ? `${rootName}.${OPTIMIZE_MIN_ALLOWED}` : OPTIMIZE_MIN_ALLOWED;
  const maxName = rootName ? `${rootName}.${OPTIMIZE_MAX_ALLOWED}` : OPTIMIZE_MAX_ALLOWED;
  const periodSelectName = rootName ? `${rootName}.${OPTIMIZE_PERIOD}` : OPTIMIZE_PERIOD;
  const period = useWatch({ name: periodSelectName }) as FrequencyPeriod;

  return (
    <FlexSummaryInset data-test={OptimizeReadyEditTestId}>
      <ConnectedFormMultiField
        hasSavedData
        names={[minName, maxName, periodSelectName] as SchemaFormKeys[]}
        labelText={<OptimizeFormLabel />}
      >
        <EditingInputRow data-border={true}>
          <OptimizeInputFields rootName={rootName} />
        </EditingInputRow>
      </ConnectedFormMultiField>
      <WithCollapsibleReadyContent collapsedContent={!!rootName} isEditing>
        <Histogram
          lastUpdated={lastUpdated}
          histogramData={histogramData.histogram_data_points}
          refreshPeriod={`${LABEL_BY_PERIOD[period]}ly`}
        />
      </WithCollapsibleReadyContent>
    </FlexSummaryInset>
  );
};
